// React Imports
import type { SVGAttributes } from 'react'

const Logo = (props: SVGAttributes<SVGElement>) => {
  return (
    <svg
      width='2.4rem'
      height='2.4rem'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      id='Layer_2'
      viewBox='0 0 160.9 164.8'
      {...props}
    >
      <defs>
        <radialGradient
          id='radial-gradient'
          cx='122.9'
          cy='55.1'
          fx='122.9'
          fy='55.1'
          r='145.9'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='#8c48ff' />
          <stop offset='.4' stopColor='#f2598a' />
          <stop offset='.9' stopColor='#ffb152' />
        </radialGradient>
        <linearGradient id='linear-gradient' x1='116' y1='18.9' x2='90.9' y2='61.4' gradientUnits='userSpaceOnUse'>
          <stop offset='.1' stopColor='#f8adfa' />
          <stop offset='.7' stopColor='#a86edd' stopOpacity='0' />
        </linearGradient>
        <radialGradient
          id='radial-gradient-2'
          cx='59'
          cy='83.2'
          fx='34.1'
          fy='83.2'
          r='68.1'
          gradientUnits='userSpaceOnUse'
        >
          <stop offset='0' stopColor='#00aeff' />
          <stop offset='.8' stopColor='#2253ce' />
          <stop offset='1' stopColor='#0736c4' />
        </radialGradient>
        <linearGradient id='linear-gradient-2' x1='75.5' y1='45.2' x2='29.4' y2='142.8' gradientUnits='userSpaceOnUse'>
          <stop offset='0' stopColor='#3dcbff' />
          <stop offset='.2' stopColor='#0588f7' stopOpacity='0' />
        </linearGradient>
      </defs>
      <g id='Layer_1-2'>
        <path
          d='M78.5,0C47.8,0,21,16.8,6.8,41.8c12.1-15.5,30.9-25.4,52.1-25.4,36.5,0,66,29.6,66,66s-29.6,66-66,66-40-10-52.1-25.4c14.2,24.9,41,41.8,71.7,41.8,45.5,0,82.4-36.9,82.4-82.4S124,0,78.5,0Z'
          fill='url(#radial-gradient)'
        />
        <path
          d='M78.5,0C47.8,0,21,16.8,6.8,41.8c12.1-15.5,30.9-25.4,52.1-25.4,36.5,0,66,29.6,66,66s-29.6,66-66,66-40-10-52.1-25.4c14.2,24.9,41,41.8,71.7,41.8,45.5,0,82.4-36.9,82.4-82.4S124,0,78.5,0Z'
          fill='url(#linear-gradient)'
        />
        <path
          d='M72.1,128.7c-25.8,0-46.7-20.9-46.7-46.7s20.9-46.7,46.7-46.7,28.3,7.1,36.8,18c-10-17.7-28.9-29.6-50.7-29.6C26.1,23.9,0,49.9,0,82.1s26.1,58.2,58.2,58.2,40.7-11.9,50.7-29.6c-8.5,11-21.9,18-36.8,18Z'
          fill='url(#radial-gradient-2)'
        />
        <path
          d='M72.1,128.7c-25.8,0-46.7-20.9-46.7-46.7s20.9-46.7,46.7-46.7,28.3,7.1,36.8,18c-10-17.7-28.9-29.6-50.7-29.6C26.1,23.9,0,49.9,0,82.1s26.1,58.2,58.2,58.2,40.7-11.9,50.7-29.6c-8.5,11-21.9,18-36.8,18Z'
          fill='url(#linear-gradient-2)'
        />
      </g>
    </svg>
  )
}

export default Logo
